import gql from 'graphql-tag'

export const SHIPS_QUERY = gql`
query CruiseCompassShips{
  ships{
    results {
      id
      name
      shippingLine {
        id
        name
      }
    }
  }
}
`